import dayjs from "dayjs";
import ApiCall from "utils/ApiCall";

// const route = `${process.env.REACT_APP_API}/api/users`;

const getConfirmationsBooking = async (query?: string, bookingFilter?: any) => {
  try {
    const route = `${process.env.REACT_APP_API}/bookings/checkin${query || ''}`
    // console.log("calling to api:", route)
    const bookings = await ApiCall.get(route);

    return bookings || []
  } catch (err) {
    throw err
  }
};

const getConfirmationsRecord = async (query?: string) => {
  // const route = `${process.env.REACT_APP_API}/prearrivals/records${query || ''}`
  const route = `${process.env.REACT_APP_API}/confirmations/records${query || ''}`
  // console.log("calling to api:", route)
  return await ApiCall.get(route);
};

const sendConfirmationNotificationEmail = async (data: any) => {
  // console.log(JSON.stringify(data))
  return await ApiCall.post(
    `${process.env.REACT_APP_API}/notifications/confirmation`,
    {...data,fromShe:true},
  );
};

const createConfirmation = async (data: any) => {
  return await ApiCall.post(
    `${process.env.REACT_APP_API}/confirmations/records`,
    { ...data, bookingNumber: data?.bookingNumber || data?.confirmationNumber },
  );
};

const deleteConfirmation = async (id: number) => {
  return await ApiCall.delete(`${process.env.REACT_APP_API}/confirmations/records/${id}`);
};

export {
  getConfirmationsRecord,
  getConfirmationsBooking,
  sendConfirmationNotificationEmail,
  createConfirmation,
  deleteConfirmation,
};
